import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterBooks } from "../../features/booksSlice";

const FilterBooks = () => {
  const dispatch = useDispatch();
  const { filter } = useSelector((state) => state.books);

  return (
    <div className="flex items-center justify-between mb-12">
      <h4 className="mt-2 text-xl font-bold">Book List</h4>
      <div className="flex items-center space-x-4">
        <button
          className={`lws-filter-btn ${filter === "All" && "active-filter"}`}
          onClick={() => dispatch(filterBooks("All"))}
        >
          All
        </button>
        <button
          className={`lws-filter-btn ${
            filter === "Featured" && "active-filter"
          }`}
          onClick={() => dispatch(filterBooks("Featured"))}
        >
          Featured
        </button>
      </div>
    </div>
  );
};

export default FilterBooks;
